module.exports = __webpack_public_path__ + "img/sync-desc.714a1624.png";